import { Difficulty } from "@all-for-one/shared-types"

type UpdateStudentDifficultyTrigger = (args: {
    classId: string
    studentId: string
    difficulty: Difficulty
}) => { unwrap: () => Promise<any> }

export const handleStudentDifficultyChange = async (
    updateStudentDifficulty: UpdateStudentDifficultyTrigger,
    classId: string,
    studentId: string,
    newDifficulty: Difficulty
) => {
    try {
        await updateStudentDifficulty({
            classId,
            studentId,
            difficulty: newDifficulty,
        }).unwrap()
        console.log('Difficulty updated successfully')
    } catch (error) {
        console.error('Failed to update difficulty:', error)
    }
}

export const getWsBaseUrl = (): string => {
    const isHttps = window.location.protocol === 'https:'
    const wsProto = isHttps ? 'wss' : 'ws'
    const hostname = window.location.hostname
    const host = hostname === 'localhost'
        ? 'api.localhost'
        : (hostname.includes('staging.')
            ? 'api.staging.allforonelearn.com'
            : 'api.allforonelearn.com')
    return `${wsProto}://${host}/ws`
}